"use strict";

const Inactivity = () => {
    const init = () => {
        $(function() {
            var $inactivity = $('.js-inactivity');
            if($inactivity.length){
                var idleTime = 0;

                if($inactivity.find('.js-inactivity-cover').length){
                    $inactivity.find('.js-inactivity-cover').on('click', function(){
                        $('body').removeClass('overflow-hidden');
                        $inactivity.find('.js-inactivity-cover').hide();
                        startIdleTimer();
                    });
                }else{
                    startIdleTimer();
                }

                function startIdleTimer(){
                    idleTime = 0;
                    //Increment the idle time counter every 15 seconds.
                    var idleInterval = setInterval(timerIncrement, 15000); 
    
                    //Zero the idle timer on mouse movement.
                    $(document).mousemove(function (e) {
                        idleTime = 0;
                    });
                    $(document).keypress(function (e) {
                        idleTime = 0;
                    });
                    
                    //Zero the idle timer on touch events.
                    $(document).bind('touchstart', function(){
                        idleTime = 0;
                    });
                    $(document).bind('touchmove', function(){
                        idleTime = 0;
                    });
                }

                function timerIncrement() {
                    idleTime = idleTime + 1;
                    if (idleTime >= 4) { //4 X 15 = 60 seconds
                        location.href = $inactivity.data('url');
                    }
                }
            }
        });
    };

    return {
        init: init,
    };
};

export default Inactivity;